<template>
  <v-card class="text-xs-center">
    <storeProductType />
  </v-card>
</template>

<script>
import storeProductType from "@/components/back-office/InStore/ProductManagement/ProductType/StoreProductTypeTable.vue";

export default {
  components: {
    storeProductType,
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage",
      },
      {
        text: "Product type list",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style>
</style>
